import { useKitbagAuth } from '@statsbomb/kitbag-auth';
import { ViewOnly } from '@statsbomb/kitbag-components';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { AUTH0_HEADER_PREFIX } from '../../AuthProvider';

export function Token() {
  const intl = useIntl();

  const [authToken, setAuthToken] = useState();
  const [authPrefix, setAuthPrefix] = useState('');

  const authState = useKitbagAuth();

  useEffect(() => {
    async function getToken() {
      const auth0Token = await authState.getAccessTokenSilently();
      setAuthToken(auth0Token);
      setAuthPrefix(AUTH0_HEADER_PREFIX);
    }
    getToken();
  }, []);

  const tokenWithPrefix = `${authPrefix}${authToken}`;

  const copyButtonTitle = intl.formatMessage({
    defaultMessage: 'Copy token with prefix to clipboard',
    id: 'dd3c4',
  });

  return (
    <ViewOnly
      icon="Clone"
      iconTitle={copyButtonTitle}
      onIconClick={() => {
        navigator.clipboard.writeText(tokenWithPrefix);
      }}
      variant="primary"
    >
      {tokenWithPrefix}
    </ViewOnly>
  );
}

export default { Token };
